<template>
  <div class="index">
    <vuescroll>
      <banner></banner>
      <div class='contect'>
        <img src="@/assets/images/index/contectBg.jpg" class="bg">
        <div class='info'>
          <img src="@/assets/images/index/infoTitle.png" class="title">
        </div>
        <div class='infoContent'>
          <div class='btContainer'>
            <img src="@/assets/images/index/pay.png" @click='tipsText="“建設中”"' class="pay">
            <img src="@/assets/images/index/buy.png" @click='goPage("https://bit.ly/FairyTownFBTW")' class="buy">
            <img src="@/assets/images/index/teach.png" @click='goPage("https://bit.ly/FairyTownGroup")' class="teach">
          </div>
          <div class='articleContainer'>
            <div class='labelContainer'>
              <div class='labelDiv'>
                <!-- <div class='label'>最新</div> -->
                <div class='label'>公告</div>
                <!-- <div class='label'>活動</div> -->
              </div>
              <div class='moreDiv'>
                <img src="@/assets/images/index/more.png" @click='$router.push("/list")'>
              </div>
            </div>
            <div class='articleList'>
              <div class='articleLine' v-for='index in 3' v-if='noticeList[index-1]' @click="goPage(noticeList[index-1].url)">
                <div class='newDiv'>
                  <img src="@/assets/images/index/new.png" class="new">
                </div>
                <div class='title'>{{noticeList[index-1].title}}</div>
                <div class='date'>{{noticeList[index-1].date}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class='char'>
          <img src="@/assets/images/index/charTitle.png" class="title">
        </div>
        <div class='charIMG'>
          <img src="@/assets/images/index/charIMG.jpg" class="image">
        </div>
        <div class='marquee'>
          <img src="@/assets/images/index/marqueeTitle.png" class="title">
        </div>
        <div class='marqueeContainer'>
          <div class="marqueeIMG" v-for='(marquee,key) in marquees' :style='marqueeAnimate(key)'>
            <img :src="marquee">
            <div :style='marqueeAnimateMb(key)'></div>
          </div>
          <div class='arrowContainer'>
            <img src="@/assets/images/index/arrow_left.png" @click="marqueeTurn(1)" class='left'>
            <img src="@/assets/images/index/arrow_right.png" @click="marqueeTurn(-1)" class='right'>
          </div>
        </div>
      </div>
      <foot></foot>
    </vuescroll>
    <div class='tips' v-if='tipsText!=""' @click="tipsText=''">
      {{tipsText}}
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import banner from '@/components/banner';
import foot from '@/components/foot';
export default {
  name: 'index',
  components:{
    vuescroll,banner,foot
  },
  data () {
    let tempnoticeList=[];
    for(let i=0;i<noticeList.length;i++){
      tempnoticeList.push({title:noticeList[i].title,url:noticeList[i].url,date:noticeList[i].date});
    }
    tempnoticeList=tempnoticeList.reverse();
    tempnoticeList.splice(3);
    for(let i=0;i<tempnoticeList.length;i++){
      let date=tempnoticeList[i].date;
      date=date.split('-');
      date=[date[1],date[2]];
      date=date.join('/');
      tempnoticeList[i].date=date;
    }
    return {
      marquees:[
        require('@/assets/images/index/marquee1.jpg'),
        require('@/assets/images/index/marquee2.jpg'),
        require('@/assets/images/index/marquee3.jpg'),
      ],
      testflag:0,
      tipsText:'',
      noticeList:tempnoticeList
    }
  },
  mounted(){
  },
  methods:{
    goPage(href){
      // console.log(href);
      window.location.href=href;
    },
    marqueeAnimate(index){
      if(index==this.testflag){
        return 'transition:.5s;transform:translate(0rem) scale(1);z-index:3';
      }
      if(index==(this.testflag+2)||index==(this.testflag-1)){
        return 'transition:.5s;transform:translate(-4.5rem) scale(.7);z-index:2';
      }
      if(index==(this.testflag+1)||index==(this.testflag-2)){
        return 'transition:.5s;transform:translate(4.5rem) scale(.7);z-index:2';
      }
    },
    marqueeAnimateMb(index){
      if(index==this.testflag){
        return 'transition:.5s;opacity:0';
      }
      if(index==(this.testflag+2)||index==(this.testflag-1)){
        return 'transition:.5s;opacity:.8';
      }
      if(index==(this.testflag+1)||index==(this.testflag-2)){
        return 'transition:.5s;opacity:.8';
      }
    },
    marqueeTurn(direction){
      this.testflag+=direction+3;
      this.testflag=this.testflag%3;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;
@contectHeight:2162/100rem;
@footHeight:174/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

@infoTitleWidth:203/100rem;
@btContainerWidth:1200/100rem;
@btWidth:214/100rem;
@articleContainerWidth:501/100rem;
@lableContainerHeight:53/100rem;

@newWidth:48/100rem;

@marqueImgWidth:1200/100rem;
.index{
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  .contect{
    position: relative;
    width: @fullWidth;
    height: @contectHeight;
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .info{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: .32rem;
      .title{
        position: absolute;
        width: @infoTitleWidth;
        left: (@fullWidth - @infoTitleWidth)/2;
        top: 0;
      }
    }
    .infoContent{
      position: absolute;
      width: @btContainerWidth;
      left: (@fullWidth - @btContainerWidth)/2;
      top: 1.85rem;
      .btContainer{
        position: absolute;
        left: 0rem;
        top: 0rem;
        .pay{
          position: absolute;
          width: @btWidth;
          left: 0rem + @btWidth*0;
          cursor:pointer;
        }
        .buy{
          position: absolute;
          width: @btWidth;
          left: 0rem + @btWidth*1;
          cursor:pointer;
        }
        .teach{
          position: absolute;
          width: @btWidth;
          left: 0rem + @btWidth*2;
          cursor:pointer;
        }
      }
      .articleContainer{
        position: absolute;
        width: @articleContainerWidth;
        height: @lableContainerHeight;
        // background: red;
        right: 0rem;
        top: 0rem;
        .labelContainer{
          position: relative;
          border-top-left-radius:.13rem;
          border-top-right-radius:.13rem;
          width: @articleContainerWidth;
          height: @lableContainerHeight;
          background: #2079df;
          overflow:hidden;
          .labelDiv{
            position: absolute;
            left: 0rem;
            top: 0rem;
            font-size:0rem;
            line-height: @lableContainerHeight;
            .label{
              display: inline-block;
              width:.92rem;
              line-height: @lableContainerHeight;
              font-size:.22rem;
              color:#ffffff;
              text-align: center;
              background:#2c54c5;
            }
          }
          .moreDiv{
            position: absolute;
            right: 0.1rem;
            top: @lableContainerHeight/4;
            font-size:0rem;
            height: @lableContainerHeight/2;
            img{
              display: inline-block;
              height: 100%;
            }
          }
        }
        .articleList{
          font-size:0rem;
          .articleLine{
            height:.42rem;
            border-bottom:dotted .02rem #ffffff;
            float:left;
            width: @articleContainerWidth;
            cursor:pointer;
            .newDiv{
              vertical-align: middle;
              width: @newWidth + .5rem;
              height:.42rem;
              text-align: center;
              font-size:0rem;
              float:left;
              .new{
                height: @newWidth/2;
                margin-top:(.42rem - @newWidth/2)/2;
                padding:0;
              }
            }
            .title{
              // display: table-cell;
              line-height:.42rem;
              font-size:.15rem;
              color:#ffffff;
              width: 3.2rem;
              float:left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .date{
              display: table-cell;
              line-height:.42rem;
              font-size:.15rem;
              color:#ffffff;
              float:right;
            }
          }
        }
      }
    }
    .char{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 4.62rem;
      .title{
        position: absolute;
        width: @infoTitleWidth;
        left: (@fullWidth - @infoTitleWidth)/2;
        top: 0;
      }
    }
    .charIMG{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 5.97rem;
      .image{
        position: absolute;
        width: @fullWidth;
        left: 0;
        top: 0rem;
      }
    }
    .marquee{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 12.67rem;
      .title{
        position: absolute;
        width: @infoTitleWidth;
        left: (@fullWidth - @infoTitleWidth)/2;
        top: 0;
      }
    }
    .marqueeContainer{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 14.06rem;
      .marqueeIMG{
        position: absolute;
        border-radius:.13rem;
        border:solid .06rem #e33556;
        width: @marqueImgWidth;
        height: 6.75rem;
        left: (@fullWidth - @marqueImgWidth)/2 - .06rem;
        top: 0;
        overflow: hidden;
        img{
          position: absolute;
          width:100%;
          left: 0;
          top: 0;
        }
        div{
          position: absolute;
          width:100%;
          height:100%;
          left: 0;
          top: 0;
          background:black;
          opacity: 0;
        }
      }
      .arrowContainer{
        position: absolute;
        width: @fullWidth;
        left: 0;
        top: (675 - 69)/200rem;
        z-index: 4;
        .left{
          position: absolute;
          width: .41rem;
          left: @fullWidth/2 - 7rem - .41rem;
          top: 0rem;
          cursor:pointer;
        }
        .right{
          position: absolute;
          width: .41rem;
          left: @fullWidth/2 + 7rem;
          top: 0rem;
          cursor:pointer;
        }
      }
    }
  }
  .tips{
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    color:#ffffff;
    text-align: center;
    line-height: 100vh;
    background: rgba(0,0,0,.8);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue